
import request from '../utils/request'
const { ocpSaasPath } = window.globalConfig;
export default class RoleApi {
  /**
   * 查询所有资源树
   * @param params
   * @returns {*|Promise<*>}
   */
  static getResourceAllForTree = () => {
    return request.post(`/${ocpSaasPath}/api/0/resource/getResourceAllForTree`, {
      prefix: 'wxb'
    })
  }
}
